import styled, { css } from 'styled-components';
import { AngleIcon } from '@/components/UI/Icons/Icons';

export const DesktopHeaderCategoryItems = styled.div<{
  $isFirstColumn?: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 320px;
  padding: 0 5px;
  overflow-y: auto;

  ${({ $isFirstColumn }) =>
    $isFirstColumn
      ? css`
          width: 315px;
          padding-left: 0;

          @media (max-width: 999px) {
            width: 31.5vw;
          }
        `
      : css`
          border-right: 1px solid
            ${({ theme }) => theme.palette.secondary.border};

          @media (max-width: 999px) {
            width: 32vw;
          }
        `}
`;

export const DesktopHeaderCategorySkeletonItem = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 50px;
  padding: 0 5px 0 15px;
  border-radius: 14px;
  gap: 15px;
`;

export const DesktopHeaderCategoryItem = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 50px;
  padding: 0 5px 0 15px;
  border-radius: 14px;
  cursor: pointer;

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background: ${({ theme }) => theme.palette.secondary.background};
      color: ${({ theme }) => theme.palette.brand.main};

      & svg {
        color: ${({ theme }) => theme.palette.brand.main};
      }
    `}
`;

export const DesktopHeaderCategoryIcon = styled.div<{
  $src: string;
}>`
  min-width: 38px;
  height: 38px;
  margin-right: 12px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  background-image: ${({ $src }) => `url(${$src})`};
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 7px;
`;

export const DesktopHeaderCategoryLabel = styled.span<{
  $isFirstColumn?: boolean;
}>`
  width: 100%;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  ${({ $isFirstColumn }) =>
    $isFirstColumn &&
    css`
      font-size: 13px;
      font-weight: 500;
      line-height: 16px;
    `}
`;

export const DesktopHeaderCategoryAngleIconBox = styled.div`
  display: flex;
  padding-left: 12px;
`;

export const DesktopHeaderCategoryAngleIcon = styled(AngleIcon)<{
  $isFirstColumn?: boolean;
}>`
  width: 16.25px;
  height: 10px;
  margin: 0 14px 0 10px;
  transform: rotate(-90deg);
  color: ${({ theme }) => theme.palette.tertiary.labels};

  ${({ $isFirstColumn }) =>
    !$isFirstColumn &&
    css`
      padding: 0 1.55px;
    `}
`;
